import React from 'react';
import { Icon } from './Icon.js';
export const IconFlag3Fill18 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "18px", ...props },
        React.createElement("path", { d: "M12.738,6.75l2.582-3.012c.191-.223,.234-.536,.112-.802-.122-.266-.388-.437-.681-.437H4V11H14.75c.293,0,.559-.17,.681-.437,.123-.266,.079-.579-.112-.802l-2.582-3.012Z", fill: "currentColor" }),
        React.createElement("path", { d: "M3.75,17c-.414,0-.75-.336-.75-.75V1.75c0-.414,.336-.75,.75-.75s.75,.336,.75,.75v14.5c0,.414-.336,.75-.75,.75Z", fill: "currentColor", "data-color": "color-2" })));
};
//# sourceMappingURL=IconFlag3Fill18.js.map